import type { DeliveryResolver } from '@grandvisionhq/shipping'
import { defaultDeliveryResolver } from '@grandvisionhq/shipping'
import { isPresent } from '@grandvisionhq/utils'

type DeliveryResolverFactory = (products?: any[], productType?: string) => DeliveryResolver

export const deliveryResolverFactory: DeliveryResolverFactory = (products, _) => {
  return (config, availability) => {
    if (Array.isArray(products)) {
      // Custom logic which VE uses at this moment:
      // - always show longest delivery time
      // - when cart contains RX (sun or frames) delivery is 7-10
      // - when cart contains non-prescription-bundle (Blue light filter for instance) delivery is 5
      // - when cart contains CL delivery is 3-5
      // - For solutions,accessories,sunglasses delivery is next day
      const types = new Set(
        products
          .filter((product) => product)
          .map((p) => p.type)
          .filter(isPresent)
      )

      const sunglasses = products.filter(
        (p) => p?.productType?.obj?.name === 'Sunglasses' || p?.productType === 'Sunglasses'
      )
      const isSunglassesWithPrescription = sunglasses.some(
        (p) =>
          p.isOfferedWithPrescriptions ||
          p.masterVariant?.isOfferedWithPrescriptions ||
          p.variants.some((v) => v.isOfferedWithPrescriptions)
      )

      const isContactLenses = products.some((p) => p?.attributes?.packageQuantity)

      if (types.has('prescription-glasses') || isSunglassesWithPrescription) {
        return ['7-10']
      } else if (types.has('non-prescription-bundle')) {
        return ['5']
      } else if (types.has('contact-lenses') || isContactLenses) {
        return ['3-5']
      } else {
        return ['1']
      }
    }

    return defaultDeliveryResolver(config, availability)
  }
}

export const deliveryResolverFactoryForOrder: DeliveryResolverFactory = (products, _) => {
  return (config, availability) => {
    if (Array.isArray(products)) {
      const types = new Set(products.map((p) => p.productType).filter(isPresent))

      const sunglasses = products.filter(
        (p) => p?.productType === 'Sunglasses' || p?.productType === 'sunglasses'
      )
      const isSunglassesWithPrescription = sunglasses.some((p) => isPresent(p.prescription))

      const isContactLenses = products.some((p) => p?.productType === 'contact-lenses')

      if (types.has('prescription-glasses') || isSunglassesWithPrescription) {
        return ['7-10']
      } else if (types.has('non-prescription-bundle')) {
        return ['5']
      } else if (types.has('contact-lenses') || isContactLenses) {
        return ['3-5']
      } else {
        return ['1']
      }
    }

    return defaultDeliveryResolver(config, availability)
  }
}
